import React, { Component } from "react";

import "./index.scss";

import { assetImg } from "@/modules/moduleImporter";
import { getATValue } from "@/modules/commonPopupResultHistory";

import { ILanguageType } from "@/types/GlobalTypes";
import { getDTCardValue } from "@/modules/cards";
import { getBasePcode } from "@/modules/gamePcode";
 
interface IProps {
	cardset: any;
	pcode: string;
	langdata: ILanguageType;
}

export default class RoadmapCardTooltip extends Component<IProps> {
// pcode: m22
// cardset: {
//	  banker: "Ad-3s-x"
//	  bankerPair: 0
//	  gamekey: "220"
//	  periode: 70
//	  player: "As-Qd-Ks"
//	  playerPair: 0
//	  result: "banker"
//	  value: 4
// }

// pcode: m23
// cardset: {dragon: "9c", tiger: "8d", value: "dragon", periode: 10, gamekey: "1"}
	render() {
		const basePcode = getBasePcode(this.props.pcode);
		const cardset = this.props.cardset;
		
		if (!cardset)
			return null; 

		//if (basePcode === "m27")
		//	console.log("m27 cardset", this.props.cardset);

		switch (basePcode) {
			// Baccarat & I4S
			case "m22":
			case "m28":
			case "m38":
				const playerVal = cardset.player.split("-")
					//.map(item => item[0] === "A" ? 1 : item[0] === "T" ? 10 : parseInt(item, 10) || 0)
					.map((num) => getATValue(num))
					.reduce((x, y) => x + y) % 10;
				const bankerVal = cardset.banker.split("-")
					// .map(item => item[0] === "A" ? 1 : item[0] === "T" ? 10 : parseInt(item, 10) || 0)
					.map(num => getATValue(num))
					.reduce((x, y) => x + y) % 10;
				
				const playerCards = cardset.player.split("-")
					.reverse()
					.map((item, idx) => 
						<div key={`pc_${idx}`} className={idx === 0 ? "lie" : ""}>
						{
							item !== "x"
							? assetImg("baccarat", item)
							: null
						}
						</div>
					);
				
				const split = cardset.banker.split("-");
				const bankerCards = [1, 0, 2].map((item, idx) =>
					<div key={`bc_${idx}`} className={idx === 2 ? "lie" : ""}>
					{
						split[item] !== "x"
						? assetImg("baccarat", split[item])
						: null
					}
					</div>
				);
				
				return (
					<div className="sl-tooltip card-tooltip-m22">
						<div className="value-container">
							<div className="player-letter">P</div>
							<div className="letter-value">
								{ playerVal }
							</div>
						</div>
						<div className="card-container">
							{ playerCards }
						</div>
						<div className="separator" />
						<div className="card-container">
							{ bankerCards }
						</div>
						<div className="value-container">
							<div className="banker-letter">B</div>
							<div className="letter-value">
								{ bankerVal }
							</div>
						</div>
					</div>
				);
			
			// Dragon & Tiger
			case "m23":
				const dragonVal = getDTCardValue(cardset.dragon);
				const tigerVal = getDTCardValue(cardset.tiger);

				const dragonCard = assetImg("baccarat", cardset.dragon),
					  tigerCard = assetImg("baccarat", cardset.tiger);
				const blackSuits = ["s", "c"];
			
				return (
					<div className="sl-tooltip card-tooltip-m23">
						<div className="extra-container">
							<div className="sl-roadmap-circle-hollow sl-roadmap-red">
								<div className="sl-hollow-value">
									{ /* red/black */ }
									{ blackSuits.indexOf(cardset.dragon[1]) >= 0 ? "B" : "R" }
								</div>
							</div>
							
							<div className="sl-roadmap-circle sl-roadmap-red">
								<div className="sl-baccarat-bead-value">
									{ /* big/small */ }
									{ dragonVal <= 5 ? "S" : "B" }
								</div>
							</div>
							
							<div className="sl-roadmap-circle-hollow sl-roadmap-red">
								<div className="sl-hollow-value">
									{ /* odd/even */ }
									{ dragonVal % 2 ? "O" : "E"}
								</div>
							</div>
						</div>
						<div className="value-container">
							<div className="player-letter dragon">D</div>
							<div className="letter-value">
								{ dragonVal }
							</div>
						</div>
						<div className="card-container">
							{ dragonCard }
						</div>
						
						<div className="separator" />
						
						<div className="card-container">
							{ tigerCard }
						</div>
						<div className="value-container">
							<div className="banker-letter tiger">T</div>
							<div className="letter-value">
								{ tigerVal }
							</div>
						</div>
						<div className="extra-container">
							<div className="sl-roadmap-circle-hollow sl-roadmap-blue">
								<div className="sl-hollow-value">
									{ /* red/black */ }
									{ blackSuits.indexOf(cardset.tiger[1]) >= 0 ? "B" : "R" }
								</div>
							</div>
							
							<div className="sl-roadmap-circle sl-roadmap-blue">
								<div className="sl-baccarat-bead-value">
									{ /* big/small */ }
									{ tigerVal <= 5 ? "S" : "B" }
								</div>
							</div>
							
							<div className="sl-roadmap-circle-hollow sl-roadmap-blue">
								<div className="sl-hollow-value">
									{ /* odd/even */ }
									{ tigerVal % 2 ? "O" : "E"}
								</div>
							</div>
						</div>
					</div>
				);

			// Shio Fights
			case "m27":
				/*
				{
					"di": "rat",
					"tian": "rooster",
					"win": "di",
					"periode": 4,
					"gamekey": 980
				}
				*/
				return (
					<div className="sl-tooltip card-tooltip-m27">
						<div className={"sl-roadmap-circle sl-roadmap-red" +
							(cardset.win === "di" ? " win" : "")}>
							{ assetImg("shio_fight_bottom", cardset.di) }
						</div>

						<div className="winner">
							<div>Winner:</div>
							<div className={cardset.win}>
							{ cardset.win }
							</div>
						</div>

						<div className={"sl-roadmap-circle sl-roadmap-blue" +
							(cardset.win === "tian" ? " win" : "")}>
							{ assetImg("shio_fight_bottom", cardset.tian) }
						</div>
					</div>
				);

			default: return null;
		}
	}
}
